import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Switch, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function PosOptions(props) {

  let { type, isDebit } = props;

  const { api, userData, currencyData, settingData, companyId, refData, yearId } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [setting, setSetting] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['setting']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    setSetting({
      posItemReverse: settingData.posItemReverse,
      moneyExchange: settingData.moneyExchange,
      useCustomerPrice: settingData.useCustomerPrice,

      showCostInCart: settingData.showCostInCart,  

      showRateOnInvoiceChange: settingData.showRateOnInvoiceChange,
      showPriceInBox: settingData.showPriceInBox,
      showCostInBox: settingData.showCostInBox, 

      startZeroSession: settingData.startZeroSession,
    })
  }, [isLoading]);


  const handleSubmit = async () => {


    setLoadingEffect(true);

    const data = {
      setting,
      companyId,
    }


    let res = await api.post(`/setting/edit`, data)
    if (res.data.status) {
      toast.success(res.data.message);
      const dataArray = ['setting']
      await refData(dataArray, companyId);
    }
    else {
      toast.error(res.data.message);
    }
    setLoadingEffect(false);
  }


  const handleChange = (name, value) => {
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <Spin spinning={loadingEffect} fullscreen />

      {isLoading &&
        <Loader />
      }

      {!isLoading &&
        <Card style={{ width: '600px' }}>

          <Row className="mb-3">
            <Col md={2}>
            </Col>
            <Col md={5}>
              <Form.Label>Reverse Item Order</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.posItemReverse ? '#23576a' : '#bebfbe' }}
                checked={setting.posItemReverse}
                onChange={(e) => handleChange('posItemReverse', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={2}>
            </Col>
            <Col md={5}>
              <Form.Label>Money Exchange</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.moneyExchange ? '#23576a' : '#bebfbe' }}
                checked={setting.moneyExchange}
                onChange={(e) => handleChange('moneyExchange', e)} />
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={2}>
            </Col>
            <Col md={5}>
              <Form.Label>use Customer Price</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.useCustomerPrice ? '#23576a' : '#bebfbe' }}
                checked={setting.useCustomerPrice}
                onChange={(e) => handleChange('useCustomerPrice', e)} />
            </Col>
          </Row>

        
          <Row className="mb-3">
            <Col md={2}>
            </Col>
            <Col md={5}>
              <Form.Label>Show rate on invoice</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.showRateOnInvoiceChange ? '#23576a' : '#bebfbe' }}
                checked={setting.showRateOnInvoiceChange}
                onChange={(e) => handleChange('showRateOnInvoiceChange', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={2}>
            </Col>    
            <Col md={5}>
              <Form.Label>Show Price in POS items box</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.showPriceInBox ? '#23576a' : '#bebfbe' }}
                checked={setting.showPriceInBox}
                onChange={(e) => handleChange('showPriceInBox', e)} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={2}>
            </Col>    
            <Col md={5}>
              <Form.Label>Show Cost in POS items box</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.showCostInBox ? '#23576a' : '#bebfbe' }}
                checked={setting.showCostInBox}
                onChange={(e) => handleChange('showCostInBox', e)} />
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={2}>
            </Col>    
            <Col md={5}>
              <Form.Label>Start Session at Zero </Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.startZeroSession ? '#23576a' : '#bebfbe' }}
                checked={setting.startZeroSession}
                onChange={(e) => handleChange('startZeroSession', e)} />
            </Col>
          </Row>


          <Row className="mb-3">
            <Col md={2}>
            </Col>    
            <Col md={5}>
              <Form.Label>Show Cost In Cart</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: setting.showCostInCart ? '#23576a' : '#bebfbe' }}
                checked={setting.showCostInCart}
                onChange={(e) => handleChange('showCostInCart', e)} />
            </Col>
          </Row>

          


          <Row>
            <Col md={5}>
            </Col>
            <Col md={6}>
              <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>Save</Button>
            </Col>
          </Row>



        </Card >
      }

    </div >


  )
}

export default PosOptions;
